var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: 5px 10px;\n  cursor: pointer;\n'], ['\n  padding: 5px 10px;\n  cursor: pointer;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  ', '\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n'], ['\n  ', '\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  ', '\n'], ['\n  ', '\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled, { css } from 'styled-components';
import InlineSVG from 'svg-inline-react';

import searchIcon from '../../assets/icons/icon-search-inactive';
import shopIcon from '../../assets/icons/icon-shop';
import emailIcon from '../../assets/icons/icon-email';
import contactIcon from '../../assets/icons/icon-contact';
import cancelIcon from '../../assets/icons/icon-cancel';
import myAccountIcon from '../../assets/icons/icon-user';
import addressIcon from '../../assets/icons/icon-address';
import flagIcon from '../../assets/icons/icon-flag';
import locationIcon from '../../assets/icons/icon-location';
import visibilityOnIcon from '../../assets/icons/icon-visibility-on';
import editIcon from '../../assets/icons/icon-edit';
import hamburgerIcon from '../../assets/icons/icon-hamburger';
import searchIconMobile from '../../assets/icons/icon-search-mobile';
import playIcon from '../../assets/icons/icon-play.svg.js';
import playIconWhite from '../../assets/icons/icon-white-play';
import eduIcon from '../../assets/icons/icon-education';
import toolsIcon from '../../assets/icons/icon-tools';
import membershipIcon from '../../assets/icons/icon-membership';
import aboutConsultantsIcon from '../../assets/icons/about-consultants-icon';
import caseStudiesIcon from '../../assets/icons/case-studies-icon';
import connectCandidatesIcon from '../../assets/icons/connect-candidates-icon';
import employerResourcesIcon from '../../assets/icons/employer-resources-icon';
import ballIronIcon from '../../assets/icons/ball-iron-icon';
import warningIcon from '../../assets/icons/warning-icon';
import closeIcon from '../../assets/icons/icon-close';
import externalLink from '../../assets/icons/externalLink';
import trashIcon from '../../assets/icons/icon-trash';
import infoIcon from '../../assets/icons/icon-info';
import calendarIcon from '../../assets/icons/icon-calendar';
import clockIcon from '../../assets/icons/icon-clock';
import golfBallIcon from '../../assets/icons/icon-golf-ball';
import globeIcon from '../../assets/icons/icon-globe';
import entryFeeIcon from '../../assets/icons/icon-entry-fee';
import captionIcon from '../../assets/icons/caption-icon';
import trophyIcon from '../../assets/icons/icon-trophy';
import backArrowIcon from '../../assets/icons/backArrow';
import greenSuccess from '../../assets/icons/icon-green-check';
import briefcaseCheckIcon from '../../assets/icons/icon-briefcase-checked';
import briefcaseGolfIcon from '../../assets/icons/icon-briefcase-golf';
import preferencesIcon from '../../assets/icons/icon-preferences';

import instagramIcon from '../../assets/icons/icon-instagram';
import websiteIcon from '../../assets/icons/website-icon';
import FbSvg from '../../assets/icons/fb';
import InSvg from '../../assets/icons/in';
import TwitterSvg from '../../assets/icons/twitter';
import GSvg from '../../assets/icons/g';
import YoutubeSvg from '../../assets/icons/youtube';
import emailErrorIco from '../../assets/icons/email-error-icon';
import emailSentIco from '../../assets/icons/email-sent-icon';
import errorTriangleIco from '../../assets/icons/error-triangle-icon';
import searchJobsIcon from '../../assets/icons/icon-search';
import execusearchIcon from '../../assets/icons/execusearch-ico';
import searcIconhBlue from '../../assets/icons/icon-search-blue';
import meetTeamIcon from '../../assets/icons/meet-team-ico';
import onlineEducationIcon from '../../assets/icons/online-education-ico';
import gmailIcon from '../../assets/icons/gmail-icon';

var iconStyles = css(_templateObject);

var IcoSvg = styled(InlineSVG)(_templateObject2, function (props) {
  return iconStyles;
}, function (_ref) {
  var pt = _ref.pt;
  return pt && 'padding-top: ' + pt + 'px';
}, function (_ref2) {
  var pr = _ref2.pr;
  return pr && 'padding-right: ' + pr + 'px';
}, function (_ref3) {
  var pb = _ref3.pb;
  return pb && 'padding-bottom: ' + pb + 'px';
}, function (_ref4) {
  var pl = _ref4.pl;
  return pl && 'padding-left: ' + pl + 'px';
}, function (props) {
  return props.pointer && 'cursor: pointer;';
});

var LinkIconDefinition = styled.i.attrs({
  className: 'fa fa-angle-right'
})(_templateObject3, iconStyles);
LinkIconDefinition.displayName = 'LinkIcon';
export var LinkIcon = LinkIconDefinition;

var SearchIconDefinition = function SearchIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: searchIcon, alt: 'search' }, props));
};
SearchIconDefinition.displayName = 'SearchIcon';
export var SearchIcon = SearchIconDefinition;

var ShopIconDefinition = function ShopIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: shopIcon, alt: 'shop' }, props));
};
ShopIconDefinition.displayName = 'ShopIcon';
export var ShopIcon = ShopIconDefinition;

var EmailIconDefinition = function EmailIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: emailIcon, alt: 'email' }, props));
};
EmailIconDefinition.displayName = 'EmailIcon';
export var EmailIcon = EmailIconDefinition;

var ContactIconDefinition = function ContactIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: contactIcon, alt: 'contact' }, props));
};
ContactIconDefinition.displayName = 'ContactIcon';
export var ContactIcon = ContactIconDefinition;

var CancelIconDefinition = function CancelIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: cancelIcon, alt: 'cancel' }, props));
};
CancelIconDefinition.displayName = 'CancelIcon';
export var CancelIcon = CancelIconDefinition;

var AddressIconDefinition = function AddressIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: addressIcon, alt: 'contact' }, props));
};
AddressIconDefinition.displayName = 'AddressIcon';
export var AddressIcon = AddressIconDefinition;

var FlagIconDefinition = function FlagIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: flagIcon, alt: 'contact' }, props));
};
FlagIconDefinition.displayName = 'FlagIcon';
export var FlagIcon = FlagIconDefinition;

var LocationIconDefinition = function LocationIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: locationIcon, alt: 'contact' }, props));
};
LocationIconDefinition.displayName = 'LocationIcon';
export var LocationIcon = LocationIconDefinition;

var UserIconDefinition = function UserIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: myAccountIcon, alt: 'contact' }, props));
};
UserIconDefinition.displayName = 'UserIcon';
export var UserIcon = UserIconDefinition;

var VisibilityOnIconDefinition = function VisibilityOnIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: visibilityOnIcon, alt: 'contact' }, props));
};
VisibilityOnIconDefinition.displayName = 'VisibilityOnIcon';
export var VisibilityOnIcon = VisibilityOnIconDefinition;

var EditIconDefinition = function EditIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: editIcon, alt: 'edit' }, props));
};
EditIconDefinition.displayName = 'EditIcon';
export var EditIcon = EditIconDefinition;

var FbIconDefinition = function FbIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: FbSvg, alt: 'Facebook' }, props));
};
FbIconDefinition.displayName = 'FacebookIcon';
export var FbIcon = FbIconDefinition;

var GIconDefinition = function GIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: GSvg, alt: 'Google' }, props));
};
GIconDefinition.displayName = 'GoogleIcon';
export var GIcon = GIconDefinition;

var InIconDefinition = function InIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: InSvg, alt: 'Linkedin' }, props));
};
InIconDefinition.displayName = 'LinkedInIcon';
export var InIcon = InIconDefinition;

var TwitterIconDefinition = function TwitterIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: TwitterSvg, alt: 'Twitter' }, props));
};
TwitterIconDefinition.displayName = 'TwitterIcon';
export var TwitterIcon = TwitterIconDefinition;

var YoutubeIconDefinition = function YoutubeIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: YoutubeSvg, alt: 'Youtube' }, props));
};
YoutubeIconDefinition.displayName = 'YoutubeIcon';
export var YoutubeIcon = YoutubeIconDefinition;

var HamburgerIconDefinition = function HamburgerIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: hamburgerIcon, alt: 'hamburger' }, props));
};
HamburgerIconDefinition.displayName = 'HamburgerIcon';
export var HamburgerIcon = HamburgerIconDefinition;

var SearchIconMobileDefinition = function SearchIconMobileDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: searchIconMobile, alt: 'search' }, props));
};
SearchIconMobileDefinition.displayNameDefinition = 'SearchIconMobile';
export var SearchIconMobile = SearchIconMobileDefinition;

var PlayIconDefinition = function PlayIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: playIcon, alt: 'play' }, props));
};
PlayIconDefinition.displayName = 'PlayIcon';
export var PlayIcon = PlayIconDefinition;

var EduIconDefinition = function EduIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: eduIcon, alt: 'education' }, props));
};
EduIconDefinition.displayName = 'EduIcon';
export var EduIcon = EduIconDefinition;

var ToolsIconDefinition = function ToolsIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: toolsIcon, alt: 'tools' }, props));
};
ToolsIconDefinition.displayName = 'ToolsIcon';
export var ToolsIcon = ToolsIconDefinition;

var MembershipIconDefinition = function MembershipIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: membershipIcon, alt: 'membership' }, props));
};
MembershipIconDefinition.displayName = 'MembershipIcon';
export var MembershipIcon = MembershipIconDefinition;

var AboutConsultantsIconDefinition = function AboutConsultantsIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: aboutConsultantsIcon, alt: 'About Consultants' }, props));
};
AboutConsultantsIconDefinition.displayName = 'AboutConsultantsIcon';
export var AboutConsultantsIcon = AboutConsultantsIconDefinition;

var CaseStudiesIconDefinition = function CaseStudiesIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: caseStudiesIcon, alt: 'Case Studies' }, props));
};
CaseStudiesIconDefinition.displayName = 'CaseStudiesIcon';
export var CaseStudiesIcon = CaseStudiesIconDefinition;

var ConnectCandidatesIconDefinition = function ConnectCandidatesIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: connectCandidatesIcon, alt: 'Connect Candidates' }, props));
};
ConnectCandidatesIconDefinition.displayName = 'ConnectCandidatesIcon';
export var ConnectCandidatesIcon = ConnectCandidatesIconDefinition;

var EmployerResourcesIconDefinition = function EmployerResourcesIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: employerResourcesIcon, alt: 'Employer Resources' }, props));
};
EmployerResourcesIconDefinition.displayName = 'EmployerResourcesIcon';
export var EmployerResourcesIcon = EmployerResourcesIconDefinition;

var BallIronIconDefinition = function BallIronIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: ballIronIcon, alt: 'Ball Iron' }, props));
};
BallIronIconDefinition.displayName = 'BallIronIcon';
export var BallIronIcon = BallIronIconDefinition;

var WarningIconDefinition = function WarningIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: warningIcon, alt: 'warning' }, props));
};
WarningIconDefinition.displayName = 'WarningIcon';
export var WarningIcon = WarningIconDefinition;

var CloseIconDefinition = function CloseIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: closeIcon, alt: 'close' }, props));
};
CloseIconDefinition.displayName = 'CloseIcon';
export var CloseIcon = CloseIconDefinition;

var ExternalLinkIconDefinition = function ExternalLinkIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: externalLink, alt: 'launch website' }, props));
};
ExternalLinkIconDefinition.displayName = 'ExternalLinkIcon';
export var ExternalLinkIcon = ExternalLinkIconDefinition;

var InstagramIconDefinition = function InstagramIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: instagramIcon, alt: 'instagram' }, props));
};
InstagramIconDefinition.displayName = 'InstagramIcon';
export var InstagramIcon = InstagramIconDefinition;

var WebsiteIconDefinition = function WebsiteIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: websiteIcon, alt: 'website' }, props));
};
WebsiteIconDefinition.displayName = 'WebsiteIcon';
export var WebsiteIcon = WebsiteIconDefinition;

var TrashIconDefinition = function TrashIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: trashIcon, alt: 'Delete' }, props));
};
TrashIconDefinition.displayName = 'TrashIcon';
export var TrashIcon = TrashIconDefinition;

var InfoIconDefinition = function InfoIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: infoIcon, alt: 'Info' }, props));
};
InfoIconDefinition.displayName = 'InfoIcon';
export var InfoIcon = InfoIconDefinition;

var CalendarIconDefinition = function CalendarIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: calendarIcon, alt: 'calendar' }, props));
};
CalendarIconDefinition.displayName = 'CalendarIcon';
export var CalendarIcon = CalendarIconDefinition;

var ClockIconDefinition = function ClockIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: clockIcon, alt: 'clock' }, props));
};
ClockIconDefinition.displayName = 'ClockIcon';
export var ClockIcon = ClockIconDefinition;

var GolfBallIconDefinition = function GolfBallIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: golfBallIcon, alt: 'golf ball' }, props));
};
GolfBallIconDefinition.displayName = 'GolfBallIcon';
export var GolfBallIcon = GolfBallIconDefinition;

var GlobeIconDefinition = function GlobeIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: globeIcon, alt: 'globe' }, props));
};
GlobeIconDefinition.displayName = 'GlobeIcon';
export var GlobeIcon = GlobeIconDefinition;

var EntryFeeDefinition = function EntryFeeDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: entryFeeIcon, alt: 'entry fee' }, props));
};
EntryFeeDefinition.displayName = 'EntryFeeIcon';
export var EntryFeeIcon = EntryFeeDefinition;

var CaptionIconDefinition = function CaptionIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: captionIcon, alt: 'caption' }, props));
};
CaptionIconDefinition.displayName = 'CaptionIcon';
export var CaptionIcon = CaptionIconDefinition;

var TrophyIconDefinition = function TrophyIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: trophyIcon, alt: 'trophy' }, props));
};
TrophyIconDefinition.displayName = 'TrophyIcon';
export var TrophyIcon = TrophyIconDefinition;

var BackArrowDefinition = function BackArrowDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: backArrowIcon, alt: 'back' }, props));
};
BackArrowDefinition.displayName = 'BackArrowIcon';
export var BackArrowIcon = BackArrowDefinition;

var successCheckmarkDefinition = function successCheckmarkDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: greenSuccess, alt: 'success' }, props));
};
successCheckmarkDefinition.displayName = 'SuccessCheckmarkIcon';
export var SuccessCheckmarkIcon = successCheckmarkDefinition;

var playIconWhiteDefinition = function playIconWhiteDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: playIconWhite, alt: 'play-icon-white' }, props));
};
playIconWhiteDefinition.displayName = 'PlayIconWhiteIcon';
export var PlayIconWhite = playIconWhiteDefinition;

var BriefcaseCheckDefinition = function BriefcaseCheckDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: briefcaseCheckIcon, alt: 'briefcase-check' }, props));
};
BriefcaseCheckDefinition.displayName = 'BriefcaseCheckIcon';
export var BriefcaseCheckIcon = BriefcaseCheckDefinition;

var BriefcaseGolfDefinition = function BriefcaseGolfDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: briefcaseGolfIcon, alt: 'briefcase-tea' }, props));
};
BriefcaseGolfDefinition.displayName = 'BriefcaseGolfIcon';
export var BriefcaseGolfIcon = BriefcaseGolfDefinition;

var preferencesDefinition = function preferencesDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: preferencesIcon, alt: 'preferences' }, props));
};
preferencesDefinition.displayName = 'PreferencesIcon';
export var PreferencesIcon = preferencesDefinition;

var EmailErrorIconDefinition = function EmailErrorIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: emailErrorIco, alt: 'email-error' }, props));
};
EmailErrorIconDefinition.displayName = 'EmailErrorIcon';
export var EmailErrorIcon = EmailErrorIconDefinition;

var EmailSentIconDefinition = function EmailSentIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: emailSentIco, alt: 'email-sent' }, props));
};
EmailSentIconDefinition.displayName = 'EmailSentIcon';
export var EmailSentIcon = EmailSentIconDefinition;

var ErrorTriangleIconDefinition = function ErrorTriangleIconDefinition(props) {
  return React.createElement(IcoSvg, _extends({ src: errorTriangleIco, alt: 'error-triangle' }, props));
};
ErrorTriangleIconDefinition.displayName = 'ErrorTriangleIcon';
export var ErrorTriangleIcon = ErrorTriangleIconDefinition;

var SearchJobsIconDef = function SearchJobsIconDef(props) {
  return React.createElement(IcoSvg, _extends({ src: searchJobsIcon, alt: 'search' }, props));
};
SearchJobsIconDef.displayName = 'SearchJobsIcon';
export var SearchJobIcon = SearchJobsIconDef;

var ExecusearchIconDef = function ExecusearchIconDef(props) {
  return React.createElement(IcoSvg, _extends({ src: execusearchIcon, alt: 'search' }, props));
};
ExecusearchIconDef.displayName = 'ExecusearchIcon';
export var ExecusearchIcon = ExecusearchIconDef;

var SearchIconBlueDef = function SearchIconBlueDef(props) {
  return React.createElement(IcoSvg, _extends({ src: searcIconhBlue, alt: 'search' }, props));
};
SearchIconBlueDef.displayName = 'SearchIconBlue';
export var SearchIconBlue = SearchIconBlueDef;

var MeetTeamIconDef = function MeetTeamIconDef(props) {
  return React.createElement(IcoSvg, _extends({ src: meetTeamIcon, alt: 'meet the team' }, props));
};
MeetTeamIconDef.displayName = 'MeetTeamIcon';
export var MeetTeamIcon = MeetTeamIconDef;

var OnlineEducationIconDef = function OnlineEducationIconDef(props) {
  return React.createElement(IcoSvg, _extends({ src: onlineEducationIcon, alt: 'online education' }, props));
};
OnlineEducationIconDef.displayName = 'OnlineEducationIcon';
export var OnlineEducationIcon = OnlineEducationIconDef;

var GmailIconDef = function GmailIconDef(props) {
  return React.createElement(IcoSvg, _extends({ src: gmailIcon, alt: 'gmail' }, props));
};
GmailIconDef.displayName = 'GmailIcon';
export var GmailIcon = GmailIconDef;